var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M7 3v18m3-15L7 3L4 6m16 12l-3 3l-3-3m3 3V3"
    }, null, -1)
  ]));
}
__name(render, "render");
const arrowsUpDown = markRaw({ name: "tabler-arrows-up-down", render });
export {
  arrowsUpDown as default
};
//# sourceMappingURL=arrows-up-down.js.map
